var util = require('../../util');

module.exports = function(data, format) {
  var d = util.isObject(data) && !util.isBuffer(data) ?
    data : JSON.parse(data);
  if (format && format.property) {
    d = util.accessor(format.property)(d);
  }
  return d;
};



//////////////////
// WEBPACK FOOTER
// ./~/datalib/src/import/formats/json.js
// module id = 93
// module chunks = 0